import { Tooltip } from '@mui/material';
import { theme } from '../constants';
import { CheckIcon, CloseIcon, UndoIcon } from './Icons';

const GREEN_TEXT = '#065f46';
const GREEN_ACTION = '#047857';

/**
 * Outcome of the last completed move, plus the reverse-move escape hatch.
 * Stays put until it is undone, dismissed, or replaced by another move.
 */
function MoveResultBanner({ move, undoing, onUndo, onClear, onDismiss }) {
  const label =
    move.devices.length === 1 ? move.devices[0].deviceName : `${move.devices.length} devices`;

  return (
    <div
      className="dmFadeIn"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 11,
        padding: '12px 16px',
        marginBottom: 16,
        borderRadius: 11,
        background: 'rgba(16,185,129,0.08)',
        border: '1px solid rgba(16,185,129,0.3)',
      }}
    >
      <span
        style={{
          width: 22,
          height: 22,
          borderRadius: '50%',
          background: theme.success,
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <CheckIcon size={13} />
      </span>

      <span style={{ flex: 1, fontSize: 13, color: GREEN_TEXT }}>
        <strong style={{ fontWeight: 700 }}>{label}</strong>{' '}
        {move.undone ? (
          <>
            {move.devices.length === 1 ? 'is' : 'are'} back on <strong style={{ fontWeight: 700 }}>{move.from}</strong>.
            The move was undone.
          </>
        ) : (
          <>
            moved from <strong style={{ fontWeight: 700 }}>{move.from}</strong> to{' '}
            <strong style={{ fontWeight: 700 }}>{move.to}</strong>. Pick another device to move again.
          </>
        )}
      </span>

      {!move.undone && (
        <Tooltip title={`Moves it back to ${move.from}`} placement="top" arrow>
          <button
            onClick={onUndo}
            disabled={undoing}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              border: `1px solid ${GREEN_ACTION}`,
              background: undoing ? 'rgba(16,185,129,0.12)' : theme.surface,
              borderRadius: 7,
              padding: '6px 13px',
              color: GREEN_ACTION,
              cursor: undoing ? 'not-allowed' : 'pointer',
              fontFamily: theme.font,
              fontSize: 12.5,
              fontWeight: 700,
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
          >
            <span className={undoing ? 'dmSpin' : undefined} style={{ display: 'flex' }}>
              <UndoIcon size={13} />
            </span>
            {undoing ? 'Undoing…' : 'Undo move'}
          </button>
        </Tooltip>
      )}

      <button
        onClick={onClear}
        disabled={undoing}
        style={{
          border: '1px solid rgba(16,185,129,0.45)',
          background: theme.surface,
          borderRadius: 7,
          padding: '6px 12px',
          color: GREEN_ACTION,
          cursor: undoing ? 'not-allowed' : 'pointer',
          opacity: undoing ? 0.6 : 1,
          fontFamily: theme.font,
          fontSize: 12.5,
          fontWeight: 700,
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        Clear properties
      </button>

      <button
        onClick={onDismiss}
        disabled={undoing}
        title="Dismiss"
        style={{
          border: 'none',
          background: 'transparent',
          color: GREEN_ACTION,
          cursor: undoing ? 'not-allowed' : 'pointer',
          opacity: undoing ? 0.6 : 1,
          display: 'flex',
          padding: 2,
          flexShrink: 0,
        }}
      >
        <CloseIcon size={14} />
      </button>
    </div>
  );
}

export default MoveResultBanner;
